<div class="mat-dialog-title">
  <p>SOLICITAÇÃO DE 2° VIA DE CARTÃO</p>
</div>

<div class="mat-dialog-content">
  <div class="data-container">
    <span class="label">Protocolo da operação:</span>
    <span class="content">{{ getProtocolNumber() }}</span>
  </div>

  <div class="data-container">
    <span class="label">Novo número de cartão:</span>
    <span class="content">{{ getCardNumber() | cardNumberFormat }}</span>
  </div>
</div>

<div class="mat-dialog-actions">
  <button mat-flat-button class="close-btn" (click)="closeDialog()">FECHAR</button>
</div>
